export enum TitleVariableType {
	ATTRIBUTE = 'ATTRIBUTE',
	METRIC_ALERT = 'METRIC_ALERT'
}

export interface SubscriptionTemplateTitleVariable {
	type: TitleVariableType;
	identifier: string;
	label: string;
}